import React, {useEffect, useState} from 'react';
import {
  Grid,
  Typography,
  makeStyles,
  CircularProgress,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import {useSnackbar} from 'notistack';
import api from '../../core/api';
import ReturnButton from '../ReturnButton';
import {Formik} from 'formik';
import InputText from './InputText';
import ButtonSubmit from './ButtonSubmit';

import Business from '../../models/Business';
import Confirm from '../Confirm';

const UserFormManager = ({
  user = {
    name: '',
    nickName: '',
    email: '',
    password: '',
    confirmPassword: '',
  },
  history,
}) => {
  const editing = !!user.id;
  const [isLoading, setIsLoading] = useState(false);
  const [getEmpresas, setEmpresas] = useState([]);
  const [selectEmpresa, setSelectEmpresa] = useState(user.business_id);
  const adminGestor = JSON.parse(localStorage.getItem('adminGestor'));

  const fetchEmpresa = async () => {
    try {
      const allEmpresas = await Business.findAll();
      setEmpresas(allEmpresas);
    } catch (e) {}
  };

  useEffect(() => {
    fetchEmpresa();
  }, []);

  const {enqueueSnackbar} = useSnackbar();

  const onSubmit = async form => {
    form.partner_id = form.partnerId || null;
    delete form.partnerId;

    form.business_id = selectEmpresa || null;
    delete form.confirmPassword;

    if (!selectEmpresa) {
      enqueueSnackbar('Selecione uma empresa.', {
        variant: 'error',
      });
      return;
    }

    const payload = {
      email: form.email.trim(),
      name: form.name,
      nickName: form.nickName,
      password: form.password,
      business_id: selectEmpresa,
      business_user: true,
      business_user_manager: true,
      isAdmin: true,
      premium: 'S',
    };

    const res = await Confirm('Deseja realmente salvar esses gestor?');

    console.log('payload', payload);

    if (res) {
      setIsLoading(true);
      try {
        await api.post(`/business_users`, payload).then(res => {
          // console.log(res);
          if (res.status === 200) {
            enqueueSnackbar('Usuário inserido com sucesso!');
            history.push('/usuarios-gestores');
          }
        });
      } catch (error) {
        if (error.response) {
          enqueueSnackbar(
            error?.response?.data?.payload?.message ||
              'Ocorreu um erro de requisição, tente novamente!',
          );
        } else if (error.request) {
          enqueueSnackbar('Sem resposta do servidor, tente novamente!');
        } else {
          enqueueSnackbar(
            'Erro na configuração da requisição, tente novamente!',
          );
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  const validateForm = values => {
    const errors = {};
    let errorMessage = '';

    if (!values.name) {
      errors.name = 'Digite um nome';
      errorMessage += 'Nome\n';
    }

    if (!values.email) {
      errors.email = 'Digite um email';
      errorMessage += 'Email\n';
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = 'Email inválido';
      errorMessage += 'Email inválido\n';
    }

    if (!user.id && !values.password) {
      errors.password = 'Digite uma senha';
      errorMessage += 'Senha\n';
    }

    if (values.password) {
      if (values.password != values.confirmPassword) {
        errors.confirmPassword = 'Senhas não são iguais';
        errorMessage += 'Confirmar senha\n';
      }
    }

    return errors;
  };

  const getPartnerFullInfo = () => {};
  // console.log(getPartners);
  console.log(getPartnerFullInfo());

  const getEmpresaFullInfo = () => {};
  // console.log(getEmpresas);
  console.log(getEmpresaFullInfo());

  const getSpecialFullInfo = () => {};
  // console.log(getSpecial);
  console.log(getSpecialFullInfo());

  return (
    <Formik
      initialValues={user}
      validate={validateForm}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={values => {
        onSubmit(values);
      }}>
      {formikProps => (
        <Grid container xs={12}>
          <Grid item xs={12} alignContent="center">
            <Typography component="h1" variant="h5">
              <ReturnButton />
              {editing ? 'Atualizar Dados' : 'Cadastrar Novo Gestor'}
            </Typography>
          </Grid>

          <Grid item xs={12} md={12} lg={12}>
            {!isLoading ? (
              <form onSubmit={formikProps.handleSubmit}>
                <div style={{display: 'flex', justifyContent: 'space_between'}}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      width: '50%',
                      height: '100px',
                      marginRight: 50,
                    }}>
                    <InputLabel style={{paddingLeft: '15px'}}>
                      Selecione a empresa
                    </InputLabel>

                    <Select
                      style={{
                        borderRadius: '40px',
                        height: 50,
                        border: 'solid 0.5px #d3d3d3',
                        padding: '0 20px',
                      }}
                      variant="outlined"
                      value={selectEmpresa}
                      label="Selecione a empresa"
                      disabled={!adminGestor}
                      onChange={e => setSelectEmpresa(e.target.value)}>
                      {getEmpresas &&
                        getEmpresas.map(e => {
                          return (
                            <MenuItem value={e.id}>{e.corporateName}</MenuItem>
                          );
                        })}
                    </Select>
                  </div>
                </div>

                <InputText
                  errorMessage={
                    formikProps.touched.name && formikProps.errors.name
                  }
                  id="name"
                  label="Nome"
                  name="name"
                  value={formikProps.values.name}
                  autoComplete="name"
                  onChange={e => {
                    formikProps.setFieldValue('name', e.target.value);
                    formikProps.errors['name'] = null;
                  }}
                />
                <InputText
                  errorMessage={
                    formikProps.touched.nickName && formikProps.errors.nickName
                  }
                  id="nickName"
                  label="Apelido"
                  name="nickName"
                  value={formikProps.values.nickName}
                  autoComplete="nickName"
                  onChange={e =>
                    formikProps.setFieldValue('nickName', e.target.value)
                  }
                />

                <InputText
                  errorMessage={
                    formikProps.touched.email && formikProps.errors.email
                  }
                  id="email"
                  label="Email"
                  name="email"
                  value={formikProps.values.email}
                  autoComplete="email"
                  onChange={e => {
                    formikProps.setFieldValue('email', e.target.value);
                    formikProps.errors['email'] = null;
                  }}
                />

                <InputText
                  errorMessage={
                    formikProps.touched.password && formikProps.errors.password
                  }
                  id="password"
                  label="Senha"
                  name="password"
                  type="password"
                  value={formikProps.values.password}
                  autoComplete="password"
                  onChange={e => {
                    formikProps.setFieldValue('password', e.target.value);
                    formikProps.errors['password'] = null;
                  }}
                />

                <InputText
                  errorMessage={formikProps.errors.confirmPassword}
                  id="confirmPassword"
                  label="Confirmar Senha"
                  name="confirmPassword"
                  type="password"
                  value={formikProps.values.confirmPassword}
                  autoComplete="confirmPassword"
                  onChange={e => {
                    formikProps.setFieldValue(
                      'confirmPassword',
                      e.target.value,
                    );
                    formikProps.errors['confirmPassword'] = null;
                  }}
                />

                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                  }}>
                  <ButtonSubmit
                    style={{
                      marginTop: 100,
                      width: '20vw',
                      alignSelf: 'center',
                    }}
                    loadingArea={isLoading}
                    type="submit"
                    variant="contained"
                    color="primary">
                    Salvar
                  </ButtonSubmit>
                </div>
              </form>
            ) : (
              <div
                className="flex-col center-a center-b"
                style={{height: '50vh'}}>
                <CircularProgress size={100} />
                <p> Carregando... </p>
              </div>
            )}
          </Grid>
        </Grid>
      )}
    </Formik>
  );
};

export default UserFormManager;
